import { styled, Switch } from '@mui/material';

export const StyledSwitch = styled(Switch)(() => ({
  padding: 5,
  height: 30,
  width: 52.8,
  transform: 'translateX(-62px)',

  '& .MuiSwitch-track': {
    borderRadius: 16,
    backgroundColor: '#c9c9cb',
    position: 'relative',
    opacity: '1 !important',
    transition: 'none !important',
    padding: '0 6px',

    '&:before, &:after': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-45%)',
      fontSize: 8.5,
      fontWeight: 600,
    },

    '&:before': {
      content: '"ON"',
      left: 7,
      visibility: 'hidden',
      color: '#2bb9bb',
    },

    '&:after': {
      content: '"OFF"',
      right: 6,
      visibility: 'visible',
    },
  },

  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },

  '& .MuiSwitch-switchBase': {
    padding: 5,
    '&.Mui-checked': {
      transform: 'translateX(22px)',
    },
  },

  '& .Mui-checked .MuiSwitch-thumb': {
    backgroundColor: '#2bb9bb !important',
  },

  '& .Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#baeeee !important',
    opacity: 1,

    '&:before': {
      visibility: 'visible',
      color: '#2bb9bb',
    },

    '&:after': {
      visibility: 'hidden',
    },
  },
}));
